"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var roleApi = _interopRequireWildcard(require("@/api/role.js"));
var systemAdminApi = _interopRequireWildcard(require("@/api/systemadmin.js"));
var _validate = require("@/utils/validate");
var _permission = require("@/utils/permission");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'SystemAdminEdit',
  props: {
    /**
     * 0 = 新增
     * 1 = 编辑
     */
    isCreate: {
      type: Number,
      required: true
    },
    editData: {
      type: Object,
      default: function _default() {
        return {
          rules: []
        };
      }
    }
  },
  data: function data() {
    var _this = this;
    /**
     * 密码正则
     *
     * 要求：
     * 1. 12-30 位
     * 2. 至少一个小写字母
     * 3. 至少一个大写字母
     * 4. 至少一个数字
     * 5. 至少一个特殊字符
     * 6. 只能使用 ASCII 可打印字符
     */
    var passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])[\x21-\x7E]{12,30}$/;

    /**
     * 手机号校验
     */
    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        callback(new Error('请填写手机号'));
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确!'));
        return;
      }
      callback();
    };
    return {
      constants: this.$constants,
      /**
       * 表单数据
       */
      pram: {
        account: null,
        level: null,
        pwd: '',
        repwd: '',
        realName: null,
        roles: [],
        status: null,
        id: null,
        phone: null
      },
      /**
       * 角色列表
       */
      roleList: {
        list: []
      },
      /**
       * 密码正则
       */
      passwordPattern: passwordPattern,
      /**
       * Element UI 表单规则
       *
       * 注意：
       * pwd / repwd 都直接使用 validator。
       * 不在其他地方动态修改 rules。
       */
      rules: {
        /**
         * 管理员账号
         */
        account: [{
          required: true,
          message: '请填管理员账号',
          trigger: ['blur', 'change']
        }],
        /**
         * 密码
         */
        pwd: [{
          required: this.isCreate === 0,
          validator: function validator(rule, value, callback) {
            /**
             * 新增模式：
             * 密码不能为空
             */
            if (_this.isCreate === 0 && !value) {
              callback(new Error('请填管理员密码'));
              return;
            }

            /**
             * 编辑模式：
             * 密码为空表示不修改密码
             */
            if (_this.isCreate === 1 && !value) {
              callback();
              return;
            }

            /**
             * 到这里说明 pwd 有值。
             *
             * 检查密码复杂度。
             */
            if (!_this.passwordPattern.test(value)) {
              callback(new Error('密码必须为12-30位，且至少包含大写字母、小写字母、数字和特殊字符'));
              return;
            }
            callback();
          },
          trigger: ['blur', 'change']
        }],
        /**
         * 确认密码
         */
        repwd: [{
          required: true,
          validator: function validator(rule, value, callback) {
            /**
             * 编辑模式：
             *
             * pwd 和 repwd 都为空，
             * 表示用户不修改密码。
             */
            if (_this.isCreate === 1 && !_this.pram.pwd && !value) {
              callback();
              return;
            }

            /**
             * 新增模式或者编辑模式下 pwd 已填写，
             * repwd 必须填写。
             */
            if (!value) {
              callback(new Error('请再次输入管理员密码'));
              return;
            }

            /**
             * 两次密码不一致
             */
            if (value !== _this.pram.pwd) {
              callback(new Error('两次输入密码不一致'));
              return;
            }
            callback();
          },
          trigger: ['blur', 'change']
        }],
        /**
         * 管理员姓名
         */
        realName: [{
          required: true,
          message: '请输入管理员姓名',
          trigger: ['blur', 'change']
        }],
        /**
         * 管理员身份
         */
        roles: [{
          required: true,
          message: '请选择管理员身份',
          trigger: ['change']
        }],
        /**
         * 手机号
         */
        phone: [{
          required: true,
          validator: validatePhone,
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  mounted: function mounted() {
    /**
     * 初始化数据
     */
    this.initEditData();

    /**
     * 获取角色列表
     */
    if ((0, _permission.checkPermi)(['admin:system:role:list'])) {
      this.handleGetRoleList();
    }
  },
  methods: {
    /**
     * 关闭弹窗
     */
    close: function close() {
      this.$emit('hideEditDialog');
    },
    /**
     * 获取角色列表
     */
    handleGetRoleList: function handleGetRoleList() {
      var _this2 = this;
      var params = {
        page: 1,
        limit: this.constants.page.limit[4],
        status: 1
      };
      roleApi.getRoleList(params).then(function (data) {
        _this2.roleList = data;
        var list = Array.isArray(data.list) ? data.list : [];

        /**
         * 后端角色 ID 转成数字
         */
        var validRoleIds = list.map(function (item) {
          return Number(item.id);
        });

        /**
         * 过滤掉已经不存在的角色
         */
        _this2.pram.roles = _this2.pram.roles.filter(function (roleId) {
          return validRoleIds.includes(Number(roleId));
        });
      });
    },
    /**
     * 初始化编辑数据
     */
    initEditData: function initEditData() {
      /**
       * 新增模式
       */
      if (this.isCreate === 0) {
        this.pram.account = null;
        this.pram.level = null;
        this.pram.pwd = '';
        this.pram.repwd = '';
        this.pram.realName = null;
        this.pram.roles = [];
        this.pram.status = null;
        this.pram.id = null;
        this.pram.phone = null;
        return;
      }

      /**
       * 编辑模式
       */
      var _this$editData = this.editData,
        account = _this$editData.account,
        realName = _this$editData.realName,
        roles = _this$editData.roles,
        level = _this$editData.level,
        status = _this$editData.status,
        id = _this$editData.id,
        phone = _this$editData.phone;
      this.pram.account = account;
      this.pram.realName = realName;
      this.pram.level = level;
      this.pram.status = status;
      this.pram.id = id;
      this.pram.phone = phone;

      /**
       * 密码绝对不能从后端回显。
       */
      this.pram.pwd = '';
      this.pram.repwd = '';

      /**
       * 处理角色
       *
       * 后端可能返回：
       *
       * "1"
       * "1,2,3"
       * [1, 2, 3]
       */
      var roleIds = [];
      if (Array.isArray(roles)) {
        roles.forEach(function (item) {
          var roleId = Number.parseInt(item);
          if (!Number.isNaN(roleId)) {
            roleIds.push(roleId);
          }
        });
      } else if (roles !== null && roles !== undefined && roles !== '') {
        String(roles).split(',').forEach(function (item) {
          var roleId = Number.parseInt(item);
          if (!Number.isNaN(roleId)) {
            roleIds.push(roleId);
          }
        });
      }
      this.pram.roles = roleIds;
    },
    /**
     * 密码输入
     *
     * pwd 改变后：
     *
     * 如果 repwd 已经输入，
     * 重新校验 repwd。
     */
    handlePwdInput: function handlePwdInput() {
      var _this3 = this;
      if (!this.$refs.pram) {
        return;
      }
      this.$nextTick(function () {
        /**
         * repwd 已经输入过才重新校验。
         */
        if (_this3.pram.repwd) {
          _this3.$refs.pram.validateField('repwd');
        }
      });
    },
    /**
     * 提交
     */
    handlerSubmit: (0, _validate.Debounce)(function (form) {
      var _this4 = this;
      /**
       * 确保表单实例存在
       */
      if (!this.$refs[form]) {
        return;
      }
      this.$refs[form].validate(function (valid) {
        /**
         * 有任何字段校验失败，
         * 不允许提交。
         */
        if (!valid) {
          return;
        }

        /**
         * 新增
         */
        if (_this4.isCreate === 0) {
          _this4.handlerSave();
          return;
        }

        /**
         * 编辑
         */
        _this4.handlerEdit();
      });
    }),
    /**
     * 新增管理员
     */
    handlerSave: function handlerSave() {
      var _this5 = this;
      /**
       * 再做一次密码一致性检查。
       *
       * 正常情况下 validate 已经检查过，
       * 这里属于最后一道保险。
       */
      if (this.pram.pwd !== this.pram.repwd) {
        this.$message.error('两次输入密码不一致');
        return;
      }

      /**
       * 创建参数
       *
       * 不把 repwd 发送给后端。
       */
      var params = _objectSpread({}, this.pram);
      delete params.repwd;
      systemAdminApi.adminAdd(params).then(function () {
        _this5.$message.success('创建管理员成功');
        _this5.$emit('hideEditDialog');
      });
    },
    /**
     * 编辑管理员
     */
    handlerEdit: function handlerEdit() {
      var _this6 = this;
      /**
       * 不直接修改 this.pram.roles。
       *
       * el-select multiple 本身需要数组。
       */
      var params = _objectSpread(_objectSpread({}, this.pram), {}, {
        roles: Array.isArray(this.pram.roles) ? this.pram.roles.join(',') : this.pram.roles
      });

      /**
       * repwd 只是前端校验字段，
       * 不提交给后端。
       */
      delete params.repwd;

      /**
       * 编辑时密码为空：
       *
       * 表示不修改密码。
       *
       * 所以不要传 pwd。
       */
      if (!params.pwd) {
        delete params.pwd;
      }
      systemAdminApi.adminUpdate(params).then(function () {
        _this6.$message.success('更新管理员成功');
        _this6.$emit('hideEditDialog');
      });
    },
    /**
     * 原有方法，保留。
     */
    rulesSelect: function rulesSelect(selectKeys) {
      this.pram.rules = selectKeys;
    }
  }
};